import clsx from 'clsx';
import React, { CSSProperties } from 'react';
import { assets } from './assets.config';

import styles from './brand.module.scss';
import { BrandVisual, brandVisuals } from './Brand.types';

export const variants = ['default', 'light', 'dark'] as const;
export type BrandVariant = (typeof variants)[number];

type BrandProps = {
  brand: BrandVisual;
  variant?: BrandVariant;
  className?: string;
  style?: CSSProperties;
};

export const Brand = ({
  brand,
  variant = 'default',
  className,
  ...props
}: BrandProps) => {
  const darkVariant = `${brand}--dark` as BrandVisual;
  const lightVariant = `${brand}--light` as BrandVisual;
  const brandLogoKey =
    variant === 'dark' && brandVisuals.includes(darkVariant)
      ? darkVariant
      : variant === 'light' && brandVisuals.includes(lightVariant)
      ? lightVariant
      : brand;

  const BrandLogoComponent = assets[brandLogoKey as BrandVisual];

  const hasVisualVariant = brandLogoKey !== brand;

  return (
    <div
      className={clsx(styles.brand, className)}
      data-brand={brand}
      data-variant={hasVisualVariant ? 'default' : variant}
      {...props}
    >
      <BrandLogoComponent />
    </div>
  );
};
